<ng-container *ngIf="!multiple; else withMultipleProducts">
  <ng-container
    *ngTemplateOutlet="
      summaryTemplate;
      context: {
        board: product,
        project: project,
        client: client,
        projectContactToCompanySubject: projectContactToCompanySubject
      }
    "
  ></ng-container>
</ng-container>

<ng-template #withMultipleProducts>
  <mat-card class="top-card mat-elevation-z0 multiple-products-summary-card">
    <ng-container
      *ngTemplateOutlet="
        summaryTemplate;
        context: {
          board: product,
          project: project,
          client: client,
          projectContactToCompanySubject: projectContactToCompanySubject
        }
      "
    ></ng-container>
  </mat-card>
</ng-template>

<ng-template
  #summaryTemplate
  let-board="board"
  let-project="project"
  let-client="client"
  let-projectContactToCompanySubject="projectContactToCompanySubject"
>
  <div class="summary-card-container">
    <div class="summary-card-header">
      Configuratie
    </div>
    <mat-card class="top-card mat-elevation-z0 summary-card black-border-color">
      <div class="bold-card-title">Projectbord</div>
      <div *ngIf="board.boardParts != null" class="part-container upper-space">
        <div
          *ngFor="
            let part of board.boardParts;
            let i = index;
            let count = count
          "
        >
          <div *ngIf="count > 1" class="strong">Bord #{{ i + 1 }}</div>
          <div>
            {{ part.height | formatProductSize: part.width }}
          </div>
          <div>
            {{
              part.boardType?.label
                | joiner
                  : ' - '
                  : (part.placementType?.ordinal
                      | placementTypeOrAlternative
                        : part.placementType?.label
                        : part.otherPlacementType
                        : '')
            }}
          </div>
          <div *ngIf="part.material != null">
            {{
              part.material.ordinal
                | materialOrAlternative
                  : part.material.name
                  : part.otherMaterial
                  : 'Ander materiaal'
            }}
          </div>
          <div class="preserve-line-break">
            <span>{{
              part.distanceToBottom
                | distanceToBottomDisplay: part.distanceToBottomText
                | joiner: ' - ':board.tilingFormats
            }}</span>
          </div>
          <div *ngIf="part.layoutDescription?.length > 0" class="upper-space">
            <span class="preserve-line-break">{{
              part.layoutDescription
            }}</span>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <client-non-ip-board-design-summary
    [product]="board"
    [project]="project"
    [client]="client"
    [projectContactToCompanySubject]="projectContactToCompanySubject"
  ></client-non-ip-board-design-summary>
</ng-template>
